module.exports = __webpack_public_path__ + "img/nevs_level_DEn.08266b6e.png";